export default __webpack_public_path__ + "static/img38h-af4f04b5b2894a1b3b630e5ecd961e0a.jpg";